import shuffleSeed from 'shuffle-seed'

import search from './search/search'
import decade from './decade/decade'
import grid from './grid/grid'

export default function(o, done){

  var archiveLabel = o.util.getTranslation(o, 'archive')
  var noResultsLabel = o.util.getTranslation(o, 'noResults')
  var loadingLabel = o.util.getTranslation(o, 'searching')

  var langs =
    _.filter(['de', 'en', 'fr', 'ru'], function(lang){
      return lang != o.store('lang')
    })

  langs.unshift(o.store('lang'))

  var resolveYears = function(years){
    if(_.includes(years,'-')){
      var range = years.split('-')
      range =
        _.map(range,function(r){
          if(r * 1 == r){
            return r * 1
          }
        })
      var length = range[1] - range[0]
      for (var i = 1; i < length; i++) {
        range.push(range[0]+i)
      }
      range = range.join(' ')
      return range
    } else if (years * 1 == years){
      return years * 1
    }
  }

  o.data.archive(o, function(archiveData){

    document.title = `Open Memory Box | ${archiveLabel}`

    var query = location.pathname.split('/')[3]

    var decadeQuery = location.pathname.split('/')[2]

    if(!decadeQuery){
      decadeQuery = 'all'
    }

    var tagsById =
      _.keyBy(archiveData.tags, '_id')

    var rollsByRoll =
      _.keyBy(archiveData.rolls, 'roll')

    var archiveDataFormated =
      _.compact(_.map(archiveData.markers, function(markerData){

        var roll = markerData.roll
        var start = markerData.start
        var tag = tagsById[markerData.tag]

        var years = rollsByRoll[markerData.roll].years
        years = resolveYears(years)

        if(!tag){
          return null
        }

        var result = {
          roll: roll,
          start: start,
          tag: tag,
          years: years,
        }

        return result

      }))

    var onQueryChange =
      function(q, d){
        if(q || q == ''){
          query = q
        }
        if(d){
          decadeQuery = d
        }
        if(query){
          var querySlug = Slug(query)
          history.replaceState({}, '', `/archive/${decadeQuery}/${querySlug}`)
        } else {
          history.replaceState({}, '', `/archive/${decadeQuery}`)
        }
        gridDiv.hide()
        noResultsDiv.hide()
        loadingDiv.show()
        setTimeout(performSearch, 500)
      }

    var keys = _.map(langs,function(lang){
      return 'tag.' + lang
    })

    keys = keys.concat('roll')
    keys = keys.concat('years')

    var fuseOptions = {
      shouldSort: true,
      threshold: 0.2,
      location: 0,
      distance: 50,
      maxPatternLength: 32,
      minMatchCharLength: 1,
      keys: keys,
    }

    var performSearch =
      function(){
        var markers = null
        var t = new Date()
        if(decadeQuery && decadeQuery != 'all'){
          var archiveDataFormatedFileteredByDecade =
            _.filter(archiveDataFormated, function(marker){
              var yearFilter = ('19' + decadeQuery).slice(0,-1)
              return _.includes(marker.years,yearFilter)
            })
        } else {
          var archiveDataFormatedFileteredByDecade = archiveDataFormated
        }
        console.log('decade duration', new Date() - t)
        if(!query){
          markers = shuffleSeed.shuffle(archiveDataFormatedFileteredByDecade,'OMB')
        } else {
          var t = new Date()
          var fuse = new Fuse(archiveDataFormatedFileteredByDecade, fuseOptions)
          markers = fuse.search(query)
          console.log('fuse duration', new Date() - t)
        }
        if(query){
          var querySlug = Slug(query)
          o.log('search',`${decadeQuery}/${querySlug}`,markers.length)
        } else {
          o.log('search',decadeQuery,markers.length)
        }
        decadeDiv.update(decadeQuery)
        gridDiv.show()
        loadingDiv.hide()
        console.log('search done')
        if(markers.length){
          noResultsDiv.hide()
          markers = markers.slice(0, 500)
          gridDiv.update(markers)
          gridDiv.scrollTop(0)  
          gridDiv.show()
        } else {
          noResultsDiv.show()
          gridDiv.hide()
        }
      }

    var gridDiv = grid(o)

    var searchDiv = search(o, query, onQueryChange)
    var decadeDiv = decade(o, onQueryChange)

    var noResultsDiv = $('<div>')
    .html(noResultsLabel)
    .css({
      textAlign: "center",
      flex: '1 1 auto',
      width: '100%',
      minHeight: 0,
      zIndex: 1,
      color: o.colors.red,
      textTransform: 'none',
      fontSize: o.fontSizeDef.s,
      marginTop: '-0.3rem',
    })
    .hide()

    var loadingDiv = $('<div>')
    .html(loadingLabel)
    .css({
      textAlign: "center",
      flex: '1 1 auto',
      width: '100%',
      minHeight: 0,
      zIndex: 1,
      color: o.colors.red,
      textTransform: 'none',
      fontSize: o.fontSizeDef.s,
      marginTop: '-0.3rem',
    })
    .hide()

    var div =
      $('<div>')
      .css(o.mainDivCss)
      .addClass('iphoneNavbarFixTop')
      .addClass('iphoneNavbarFixBottom')  
      .append([

        o.component.menu(o)
        .css({
          flex: '0 0 auto',
          width: '100%',
          zIndex: 1,
        }),

        searchDiv
        .css({
          flex: '0 0 auto',
          padding: '0 1rem',
          width: '100%',
          zIndex: 1,
          marginTop: '-0.8rem',
        }),

        decadeDiv
        .css({
          flex: '0 0 auto',
          padding: '0 1rem',
          marginTop: '0.1rem',
          width: '100%',
          zIndex: 1,
        }),

        $('<div>')
        .css({
          flex: '0 0 auto',
          height: '0.8rem',
        }),

        gridDiv
        .css({
          flex: '1 1 auto',
          width: '100%',
          overflowY: 'auto',
          '-webkit-overflow-scrolling': 'touch',
          minHeight: 0,
          zIndex: 1,
        }),

        noResultsDiv,

        loadingDiv,

      ])

    if(o.isTouch){
      gridDiv.on('touchstart',function(){
        // console.log('touchstart',searchDiv.input.is(':focus'))
        if(searchDiv.input.is(':focus')){
          searchDiv.input.blur()
        }
      })
    }

    var observer =
      new MutationObserver(function(){
        if (document.body.contains(div[0])){

          observer.disconnect()

          searchDiv.start()

          gridDiv.update()

          if(o.store('archiveScrollTop')){
            gridDiv.scrollTop(o.store('archiveScrollTop'))
          }

        }
      })

    observer.observe(document.body, {childList: true});

    done(div)

    performSearch()

  })

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/views/archive/archive.js